export default __webpack_public_path__ + "static/media/ring-0@3x.5eefaeef.jpg";